import { render, staticRenderFns } from "./VacationList.vue?vue&type=template&id=75347e91&scoped=true&"
import script from "./VacationList.vue?vue&type=script&lang=js&"
export * from "./VacationList.vue?vue&type=script&lang=js&"
import style0 from "./VacationList.vue?vue&type=style&index=0&id=75347e91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75347e91",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VIcon,VListItem,VListItemContent,VRow})
